import { u21CreateSlice } from 'app/shared/thunk/u21CreateSlice';
import { u21CreateAsyncThunk } from 'app/shared/thunk/u21CreateAsyncThunk';
import { Filter } from 'app/modules/filters/models';
import { LocalStorageKeys } from 'app/shared/constants/localStorage';

export const SCHEDULE_SLICE_NAME = 'schedule';

interface ScheduleState {
  agentFilters: Filter[];
}

const INITIAL_STATE: ScheduleState = {
  agentFilters: [],
};

export const setScheduleAgentFilters = u21CreateAsyncThunk<Filter[], Filter[]>(
  `${SCHEDULE_SLICE_NAME}/SET_SCHEDULE_AGENT_FILTERS`,
  (payload) => {
    localStorage.setItem(
      LocalStorageKeys.SCHEDULE_AGENTS_FILTERS,
      JSON.stringify(payload),
    );
    return payload;
  },
);

export const slice = u21CreateSlice({
  initialState: INITIAL_STATE,
  name: SCHEDULE_SLICE_NAME,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setScheduleAgentFilters.fulfilled, (draft, action) => {
      draft.agentFilters = action.payload;
    });
  },
});

export default slice.reducer;
